// extracted by mini-css-extract-plugin
export default {"bgImage1":"contatc_bgImage1__JJ1sB","bgImage":"contatc_bgImage__GgbbZ","contact":"contatc_contact__KrIRQ","layer":"contatc_layer__gQJzN"};